import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  FormCheckbox,
  Col,
  Row,
  Form,
  FormGroup,
  FormSelect,
} from "shards-react";
import moment from "moment";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from "react-toastify";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import {
  SelectIndicatorsAgencySetting,
  SelectIndicatorsDataset,
} from "shared/components";

const axios = require("axios").default;

const ModalClose = styled.a`
  color: black;
  cursor: pointer;
  position: absolute;
  right: 20px;
  :hover {
    color: black;
  }
`;
const StyledModalFooter = styled(ModalFooter)`
  display: block;
`;

const ModalCreateEmail = (props) => {
  const { token } = useToken();
  const { open, toggle } = props;
  const [dataAdminEmail, setDataAdminEmail] = useState([]);
  const [indicatorsDatasetId, setIndicatorsDatasetId] = useState("");
  const [agencyId, setAgencyId] = useState("");
  const [importName, setImportName] = useState("รายปี");
  const [notiEnable, setNotiEnable] = useState(0);
  const [typeUserNoti, setTypeUserNoti] = useState([]);
  const [emailNotiDate, setEmailNotiDate] = useState("");
  const [emailNotiDate2, setEmailNotiDate2] = useState("");
  const [emailNotiDate3, setEmailNotiDate3] = useState("");
  const [emailNotiDate4, setEmailNotiDate4] = useState("");

  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          emailNotiId: "",
        },
        show: 1000,
        page: 1,
        orderBy: "emailNotiId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/emailnotilist`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setDataAdminEmail(response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);
  const handleCheckbox = (event, value) => {
    var settypeUserNoti = [...typeUserNoti];
    var newtypeUserNoti = settypeUserNoti.filter(
      (item) => item.emailTypeUserId === value
    );
    if (newtypeUserNoti.length > 0) {
      var newset = settypeUserNoti.filter(
        (item) => item.emailTypeUserId !== value
      );
      setTypeUserNoti(newset);
    } else {
      settypeUserNoti.push({
        emailTypeUserId: value,
      });
      setTypeUserNoti(settypeUserNoti);
    }
  };
  const isChecked = (number) => {
    var newtypeUserNoti = typeUserNoti.filter(
      (item) => item.emailTypeUserId === number
    );
    if (newtypeUserNoti.length > 0) {
      return true;
    } else {
      return false;
    }
  };
  const isDisabled = () => {
    if (!indicatorsDatasetId || !agencyId) {
      return true;
    }
    if (importName === "รายปี" && !emailNotiDate) {
      return true;
    }
    if (
      importName === "รายไตรมาส" &&
      (!emailNotiDate || !emailNotiDate2 || !emailNotiDate3 || !emailNotiDate4)
    ) {
      return true;
    }
    return false;
  };
  const onSaveNotiEmail = () => {
    const sendObject = {
      indicatorsDatasetSettingId: indicatorsDatasetId,
      indicatorsAgencySettingId: agencyId,
      importName: importName,
      emailTypeUser: typeUserNoti,
      notiEnable: notiEnable,
    };
    if(importName=== "รายปี"){
      sendObject["emailNotiDate"] = moment(emailNotiDate).format("YYYY-MM-DD");
    }else{
      sendObject["emailNotiDate"] =  moment(emailNotiDate).format("YYYY-MM-DD");
      sendObject["emailNotiDate2"] = moment(emailNotiDate2).format("YYYY-MM-DD");
      sendObject["emailNotiDate3"] = moment(emailNotiDate3).format("YYYY-MM-DD");
      sendObject["emailNotiDate4"] = moment(emailNotiDate4).format("YYYY-MM-DD");
    }
    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/createemailnoti`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: sendObject,
    };

    axios(config)
      .then((response) => {
        toggle();
        showNotify("แจ้งเตือน! บันทึกข้อมูลเรียบร้อย");
      })
      .catch((error) => {
        console.log(error);
        showNotify(error.message, "error");
      });
  };
  let emailList = [];
  dataAdminEmail.map((item) => {
    emailList.push(item.indicatorsDatasetSettingId);
  });

  return (
    <>
      <Modal size="lg" open={open} toggle={toggle}>
        <ModalHeader tag="h6" titleClass="bold" style={{ border: "none" }}>
          เพิ่มรายการข้อมูล/ตัวชี้วัด
          <ModalClose onClick={toggle}>
            <FontAwesomeIcon icon={faCircleXmark} />
          </ModalClose>
        </ModalHeader>
        <ModalBody>
          <Form className="my-form">
            <FormGroup className="mt-2">
              <label>หน่วยงานเจ้าของข้อมูล</label>
              <SelectIndicatorsAgencySetting
                placeholder="เลือก"
                name="indicatorsAgencySettingId"
                // disabled
                onChange={(e) => {
                  setAgencyId(e.target.value);
                  setIndicatorsDatasetId("");
                }}
                defaultValue={agencyId}
                value={agencyId}
              />
            </FormGroup>
            <FormGroup className="mt-2">
              <label>ข้อมูลตัวชี้วัด</label>
              <SelectIndicatorsDataset
                placeholder="เลือก"
                name="indicatorsDatasetSettingId"
                // disabled
                onChange={(e) => {
                  setIndicatorsDatasetId(e.target.value);
                }}
                agencySettingId={agencyId}
                defaultValue={indicatorsDatasetId}
                value={indicatorsDatasetId}
                selectFilterIndicator={emailList}
              />
            </FormGroup>
            <FormGroup className="mt-2">
              <label>การนำเข้าข้อมูล</label>
              <FormSelect
                name="importName"
                value={importName}
                onChange={(e) => {
                  setImportName(e.target.value);
                  setEmailNotiDate("")
                  setEmailNotiDate2("")
                  setEmailNotiDate3("")
                  setEmailNotiDate4("")
                }}
              >
                <option value="รายไตรมาส">รายไตรมาส</option>
                <option value="รายปี">รายปี</option>
              </FormSelect>
            </FormGroup>
            {importName === "รายปี" ? (
              <Row>
                <Col md="4">
                  <FormGroup className="mt-2">
                    <label>วันที่นำเข้าข้อมูลรายปี</label>
                    <DatePicker
                      placeholderText="DD/MM"
                      className="form-control"
                      dateFormat="dd/MM"
                      selected={emailNotiDate}
                      onChange={(date) =>  setEmailNotiDate(date)}
                    />
                  </FormGroup>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col md="4">
                  <FormGroup className="mt-2">
                    <label>ไตรมาส1</label>
                    <DatePicker
                      placeholderText="DD/MM"
                      className="form-control"
                      dateFormat="dd/MM"
                      selected={emailNotiDate}
                      onChange={(date) => setEmailNotiDate(date)}
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup className="mt-2">
                    <label>ไตรมาส2</label>
                    <DatePicker
                      placeholderText="DD/MM"
                      className="form-control"
                      dateFormat="dd/MM"
                      selected={emailNotiDate2}
                      onChange={(date) => setEmailNotiDate2(date)}
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup className="mt-2">
                    <label>ไตรมาส3</label>
                    <DatePicker
                      placeholderText="DD/MM"
                      className="form-control"
                      dateFormat="dd/MM"
                      selected={emailNotiDate3}
                      onChange={(date) => setEmailNotiDate3(date)}
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup className="mt-2">
                    <label>ไตรมาส4</label>
                    <DatePicker
                      placeholderText="DD/MM"
                      className="form-control"
                      dateFormat="dd/MM"
                      selected={emailNotiDate4}
                      onChange={(date) => setEmailNotiDate4(date)}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}
            <FormGroup className="mt-2">
              <label>ประเภทผู้ใช้งานที่ได้รับการแจ้งเตือน</label>
              <div>
                <FormCheckbox
                  inline
                  checked={isChecked(1)}
                  onChange={(e) => handleCheckbox(e, 1)}
                >
                  ผู้นำเข้าข้อมูล
                </FormCheckbox>
                <FormCheckbox
                  inline
                  checked={isChecked(2)}
                  onChange={(e) => handleCheckbox(e, 2)}
                >
                  ผู้ตรวจสอบ/เผยแพร่
                </FormCheckbox>
                <FormCheckbox
                  inline
                  checked={isChecked(3)}
                  onChange={(e) => handleCheckbox(e, 3)}
                >
                  ผู้ดูแลระบบ
                </FormCheckbox>
              </div>
            </FormGroup>
            <FormGroup className="mt-2">
              <label>สถานะแจ้งเตือน</label>
              <FormCheckbox
                toggle
                checked={notiEnable === 1 ? true : false}
                onChange={(e) => setNotiEnable(notiEnable === 1 ? 0 : 1)}
              >
                {notiEnable === 1 ? "เปิด" : "ปิด"}
              </FormCheckbox>
            </FormGroup>
          </Form>
        </ModalBody>
        <StyledModalFooter>
          <Button
            className="btn-success pull-right"
            onClick={onSaveNotiEmail}
            style={{ width: "150px" }}
            disabled={isDisabled()}
          >
            บันทึกข้อมูล
          </Button>
          <Button className="btn-white  pull-right" onClick={toggle}>
            ยกเลิก
          </Button>
        </StyledModalFooter>
      </Modal>
    </>
  );
};

export default ModalCreateEmail;
